module.exports = __webpack_public_path__ + "static/media/icon-package.13f7070f.svg";